var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6471 5.61332C16.5959 4.43408 16.4525 3.6664 16.0508 3.05911C15.8197 2.70973 15.5327 2.40586 15.2027 2.16123C14.3107 1.5 13.0522 1.5 10.5354 1.5H7.46529C4.94843 1.5 3.69 1.5 2.79796 2.16123C2.46793 2.40586 2.18088 2.70973 1.94978 3.05911C1.54815 3.66633 1.40477 4.43391 1.35359 5.61292C1.34483 5.81453 1.5185 5.96875 1.70878 5.96875C2.76849 5.96875 3.62756 6.87818 3.62756 8C3.62756 9.12182 2.76849 10.0312 1.70878 10.0312C1.5185 10.0312 1.34483 10.1855 1.35359 10.3871C1.40477 11.5661 1.54815 12.3337 1.94978 12.9409C2.18088 13.2902 2.46793 13.5941 2.79796 13.8388C3.69 14.5 4.94843 14.5 7.46529 14.5H10.5354C13.0522 14.5 14.3107 14.5 15.2027 13.8388C15.5327 13.5941 15.8197 13.2902 16.0508 12.9409C16.4525 12.3336 16.5959 11.5659 16.6471 10.3867V5.61332Z",
    fill: "white",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76465 8H12.8235",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70581 11.0586H12.8235",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketDay);
export default __webpack_public_path__ + "static/media/ticket-day.1c3d8da24728e5bc62e2add1190f4a9d.svg";
export { ForwardRef as ReactComponent };